import styled, {keyframes} from 'styled-components';


const buttonHoverEffect = keyframes`
    0% {width: 0}
    100% {width: 100%}
`


export const LearnersRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${props => props.justify};
    /* text-transform: uppercase; */
    background-color: ${props => props.backgroundColor ? props.backgroundColor : '#1a1a1a'};
    width:${props => props.width ? props.width : '100%'};
    padding: ${props => props.padding ? props.padding : '0em 2em 4em 2em'};
    margin: ${props => props.margin ? props.margin : 0};

    h2.row-heading,  h2.row-subheading {
        font-size: 35px;
        margin-top: -.5em;
        font: italic bold 35px 'Roboto Condensed';
            text-transform: uppercase;

    }

    h2.row-subheading {
        font-size: 28px;
    }

    div.learners-row {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        max-width: 1600px;
        margin-top: 2em;
    }

    p.help-text, p.help-small{text-transform: none; text-align: center; font-size: 15px; font-style: italic; height: 100px; }

    p.help-small {height: 50px;}

    p.note {text-transform: none; text-align: center; color: var(--blue);}
`

export const GradientList = styled.div`
    display: flex;
    flex-direction: column;
    width: 374px;
    align-items: center;
    margin: 0 1em;

    .list-title {
        text-align: center;
        font: italic bold 20px 'Roboto Condensed';
        text-transform: uppercase;
    }

    p.list-empty {
        text-align: center;
        font: italic bold 14px 'Roboto Condensed';
        margin-top: 1.5em;
        color: var(--red);
        text-transform: none;
    }
`

export const GradientListItem = styled.button`
    border-width: 2px;
    border-style: solid;
    border-color: ${props => props.highlightColor ? props.highlightColor : "#acff24"};
    outline: none;
    display: flex;
    position: relative;
    justify-content: flex-start;
    align-items: center;
    background: transparent;
    width: 100%;
    height: 55px;
    margin: .5em 0;
    color: #fff;
    padding-left: 1em;
    transition: all 300ms ease;
    z-index: 1;
        text-transform: uppercase;


    ::before {
        content: '';
        width: 0;
        height: 100%;
        position: absolute;
        background-color: ${props => props.highlightColor};
        top: 0; left: 0;
        z-index: -1;
    }

    :hover {color: black;}


    :hover::before {
        animation: ${buttonHoverEffect} 0.6s ease;
        animation-fill-mode: forwards;
    }


    /* :hover {
        border-width: 2px;
        border-style: solid;
        border-color: ${props => props.highlightColor ? props.highlightColor : "#acff24"};
        transform: scale(1.01);
        color: #fff;
        transition: all 300ms ease;
    } */
`

export const PerceptionsItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2em;
    font: bold italic 22px 'Roboto Condensed';

    .perceptions-title {
        text-align: center;
        margin-bottom: 1em;
    }

    .perceptions-button {
        width: 230px;
        height: 230px;
        border-radius: 50%;
        background-color: ${props => props.bgColor};
        color: ${props => props.color};
        display: flex;
        align-items: center;
        justify-content: center;
    }
`




// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/QuickGlance/QuickGlance.styles.ts